import { render } from "./OpenView.vue?vue&type=template&id=03b9cd2e&scoped=true&ts=true"
import script from "./OpenView.vue?vue&type=script&lang=ts"
export * from "./OpenView.vue?vue&type=script&lang=ts"

import "./OpenView.vue?vue&type=style&index=0&id=03b9cd2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b9cd2e"]])

export default __exports__